<template>
  <c-box>
    <c-box class="drawer-container" :d="{ base: 'block', md: 'none' }">
      <c-box
        ref="btnRef"
        bg="brand.beigeLight"
        ml="-100px"
        pl="100px"
        pt="0.6rem"
        pb="0.6rem"
        pr="3xl"
        roundedRight="full"
        d="inline-block"
        cursor="pointer"
        @click="openDrawer()"
      >
        <slot name="drawerButton"></slot>
      </c-box>
      <c-drawer :isOpen="isDrawerOpen" placement="left" :on-close="closeDrawer">
        <c-drawer-overlay />
        <c-drawer-content maxW="244px">
          <c-drawer-close-button position="absolute" bg="rgba(0, 0, 0, 0)" />
          <c-drawer-body
            pt="4xl"
            pl="3xl"
            overflowY="scroll"
            fontSize="md"
            fontWeight="300"
            lineHeight="1.6"
          >
            <slot></slot>
          </c-drawer-body>
        </c-drawer-content>
      </c-drawer>
    </c-box>
    <c-box class="non-drawer-container" :d="{ base: 'none', md: 'block' }">
      <slot></slot>
    </c-box>
  </c-box>
</template>

<script lang="ts">
import {
  CBox,
  CDrawer,
  CDrawerBody,
  CDrawerCloseButton,
  CDrawerContent,
  CDrawerOverlay,
  CIcon,
} from "@chakra-ui/vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    CIcon,
    CBox,
    CDrawer,
    CDrawerBody,
    CDrawerOverlay,
    CDrawerContent,
    CDrawerCloseButton,
  },
  data() {
    return {
      isDrawerOpen: false,
    };
  },
  methods: {
    openDrawer() {
      this.isDrawerOpen = true;
    },
    closeDrawer() {
      this.isDrawerOpen = false;
    },
  },
});
</script>
